import { ActionCreator, AnyAction, Reducer } from 'redux';
import { RootState, ThunkActionCreator } from 'shared/state';
import { fetchAllSiteVersions as dofetchAllSiteVersions } from 'shared/api/sites';

/**
 * Site actions
 */
export const FETCH_ALL_SITE_VERSIONS_PENDING =
  'duplo/sites/FETCH_ALL_SITE_VERSIONS_PENDING';
export const FETCH_ALL_SITE_VERSIONS_FULFILLED =
  'duplo/sites/FETCH_ALL_SITE_VERSIONS_FULFILLED';
export const FETCH_ALL_SITE_VERSIONS_FAILED =
  'duplo/sites/FETCH_ALL_SITE_VERSIONS_FAILED';

export interface State {
  data: {
    allSiteVersions: Array<Site>;
  };
  meta: StateMeta;
}

const defaultState: State = {
  data: {
    allSiteVersions: [],
  },
  meta: {
    pending: false,
  },
};

const reducer: Reducer<State> = (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_ALL_SITE_VERSIONS_PENDING:
      return {
        ...state,
        meta: {
          ...state.meta,
          pending: true,
        },
      };
    case FETCH_ALL_SITE_VERSIONS_FULFILLED:
      return {
        ...state,
        data: {
          allSiteVersions: action.allSiteVersions,
        },
        meta: {
          ...state.meta,
          pending: false,
          successful: true,
          error: null,
        },
      };
    case FETCH_ALL_SITE_VERSIONS_FAILED:
      return {
        ...state,
        meta: {
          ...state.meta,
          pending: false,
          successful: false,
        },
      };
    default:
      return state;
  }
};

export default reducer;

/**
 * Action creators
 */

const fetchAllSiteVersionsFailed: ActionCreator<AnyAction> = () => {
  return { type: FETCH_ALL_SITE_VERSIONS_FAILED };
};

const fetchAllSiteVersionsPending: ActionCreator<AnyAction> = () => {
  return { type: FETCH_ALL_SITE_VERSIONS_PENDING };
};

const fetchAllSiteVersionsFulfilled: ActionCreator<AnyAction> = (
  allSiteVersions: Array<any>
) => {
  return {
    type: FETCH_ALL_SITE_VERSIONS_FULFILLED,
    allSiteVersions,
  };
};

export const fetchAllSiteVersions: ThunkActionCreator = (
  siteId: number
) => dispatch => {
  dispatch(fetchAllSiteVersionsPending());
  dofetchAllSiteVersions(siteId)
    .then(allSiteVersions => {
      dispatch(fetchAllSiteVersionsFulfilled(allSiteVersions));
    })
    .catch(_ => {
      dispatch(fetchAllSiteVersionsFailed());
    });
};

/**
 * Selectors
 */

export const selectAllSiteVersions = (state: RootState) =>
  state.siteVersions?.data.allSiteVersions || [];

export const selectSiteVersionsPending = (state: RootState) =>
  state.siteVersions?.meta.pending ?? false;
